import ApiService from "@/services/api.service"

export const ServicesService = {
  getAllServices(params) {
    return ApiService.get(`services/tree/all`, params, { loader: false })
  },
  getAllServicesByPrices(params) {
    return ApiService.get(`services/tree/all/prices`, params, { loader: false })
  },
}
